import axios from './axios';

export const forgotPassword = async (contact, channel) => {
  const response = await axios.post('/api/v1/auth/forgot-password', {
    contact,
    channel,
  });
  return response?.data || response;
};

export const verifyResetOtp = async (contact, code) => {
  const response = await axios.post('/api/v1/auth/verify-reset-otp', {
    contact,
    code,
  });
  return response?.data || response;
};

export const resetPassword = async (resetToken, password, passwordConfirmation) => {
  const response = await axios.post('/api/v1/auth/reset-password', {
    reset_token: resetToken,
    password,
    password_confirmation: passwordConfirmation,
  });
  return response?.data || response;
};

export const sendLoginOtp = async (contact, channel) => {
  const response = await axios.post('/api/v1/auth/login-otp/send', {
    contact,
    channel,
  });
  return response?.data || response;
};

export const verifyLoginOtp = async (contact, code, deviceName) => {
  const response = await axios.post('/api/v1/auth/login-otp/verify', {
    contact,
    code,
    device_name: deviceName,
  });
  return response?.data || response;
};
